import { render } from "./PreguntaDialog.vue?vue&type=template&id=13132616&scoped=true"
import script from "./PreguntaDialog.vue?vue&type=script&lang=js"
export * from "./PreguntaDialog.vue?vue&type=script&lang=js"

import "./PreguntaDialog.vue?vue&type=style&index=0&id=13132616&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13132616"]])

export default __exports__